import React from 'react';
import { Badge, Box, Flex, IconButton, Stack, Text, Tooltip } from '@chakra-ui/react';
import { Sliders } from 'phosphor-react';

import { describeCriterio, ICriterioFechamento } from '../../../../../hooks/useCriterioFechamento';
import { InfoPopover } from './InfoPopover';

interface CriterioCalculoInlineProps {
  criterio: ICriterioFechamento;
  onOpen: () => void;
}

const BADGE_COLOR: Record<string, string> = {
  Estrito: 'red',
  Intermediário: 'orange',
  Tolerante: 'green',
  Personalizado: 'purple',
};

/**
 * Bloco compacto para encaixar no canto superior direito do hero,
 * logo abaixo do toggle de escopo. Versao "card grande" foi substituida
 * por isso pra ocupar menos espaco vertical.
 */
export const CriterioCalculoCard = ({ criterio, onOpen }: CriterioCalculoInlineProps) => {
  const desc = describeCriterio(criterio);
  const badgeColor = BADGE_COLOR[desc.badge] ?? 'blue';

  return (
    <Stack spacing={1} align="flex-end" maxW={{ base: '100%', md: '380px' }}>
      <Flex align="center" gap={1.5}>
        <Badge
          colorScheme={badgeColor}
          fontSize="9px"
          borderRadius="full"
          px={2}
          textTransform="uppercase"
          letterSpacing="0.06em"
        >
          {desc.badge}
        </Badge>
        <Text fontSize="11px" fontWeight="700" color="#0F172A" letterSpacing="-0.01em">
          {desc.titulo}
        </Text>
        <InfoPopover title="Critério de cálculo">
          <Stack spacing={2}>
            <Text fontSize="xs" color="gray.700" lineHeight="1.5">
              {desc.detalhe}
            </Text>
            <Box pt={2} borderTop="1px solid" borderColor="gray.100">
              <Text
                fontSize="10px"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="0.08em"
                fontWeight="600"
                mb={1}
              >
                Janela aplicada
              </Text>
              <Text fontSize="xs" color="gray.800" fontWeight="600">
                {desc.janela}
              </Text>
            </Box>
            <Text fontSize="10px" color="gray.400" pt={1}>
              Aplica-se só a clientes ativos. Inativos continuam sendo avaliados pela data de saída.
            </Text>
          </Stack>
        </InfoPopover>
        <Tooltip label="Trocar critério" placement="top" fontSize="xs">
          <IconButton
            aria-label="Trocar critério"
            icon={<Sliders size={13} />}
            size="xs"
            variant="ghost"
            color="#1B88F5"
            _hover={{ bg: 'rgba(27, 136, 245, 0.1)' }}
            onClick={onOpen}
            h="auto"
            minW="auto"
            p={1}
          />
        </Tooltip>
      </Flex>
      {/* Texto curto debaixo do titulo. A janela completa fica so no
          InfoPopover acima — antes estava duplicada nos dois lugares. */}
      <Text fontSize="10px" color="#94A3B8" letterSpacing="-0.005em">
        {desc.subtitulo}
      </Text>
    </Stack>
  );
};
